import { DemandInformationCategory } from '../../../types/DemandInformationMessage';
import { sortCategory as sortTankCategory } from '../../common/helpers/sortByCategory.helper';

export const sortCategory = (a: DemandInformationCategory, b: DemandInformationCategory): number => {
    if (a.tankCategory && b.tankCategory) {
        return sortTankCategory(a.tankCategory, b.tankCategory);
    }

    return 0;
};
